export default __webpack_public_path__ + "static/media/Avatar.798935f7.svg";